import React, { useEffect, useState, useContext } from 'react';
import ReactSlidingPane from 'react-sliding-pane';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import FetalMovement from '../info/FetalMovement';
import { AuthContext } from '../../context/AuthContext';
import Profile from '../profile/Profile';

const infoIcon = require('../../assets/icons/info_icon.svg').default;
const closeIcon = require('../../assets/icons/close.svg').default;
const titleImage = require('../../assets/images/title.svg').default;
const titleMobileImage = require('../../assets/icons/fluttercare.svg').default;

export default function Navbar() {
  const [openPanel, setOpenPanel] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('transparent');
  const [showProfile, setShowProfile] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const mql = window.matchMedia('(max-width: 900px)');
  const slidingPanelWidth = mql.matches ? '100vw' : '40vw';

  useEffect(() => {
    if (location.pathname === '/') {
      setShowInfo(false);
      setShowProfile(false);
      setBackgroundColor('transparent');
    } else if (location.pathname === '/kick-counter') {
      setShowInfo(true);
      setShowProfile(false);
      setBackgroundColor('white');
    } else {
      setShowInfo(false);
      setShowProfile(true);
      setBackgroundColor('white');
    }
  }, [location]);

  return (
    <div className={styles.navBar} style={{ backgroundColor }}>
      <nav>
        <Link to="/">
          <img src={titleImage} alt="Flutter Care" className={styles.desktopImage} />
          <img src={titleMobileImage} alt="Flutter Care" className={styles.mobileImage} />
        </Link>
      </nav>
      <div className={styles.rightContainer}>
        { showInfo && (
        <button type="button" className="infoButton" onClick={() => setOpenPanel(true)}>
          <img src={infoIcon} alt="" />
          <div>
            Why do I need to count fetal movement?
          </div>
        </button>
        )}
        { showProfile && user && <Profile />}
      </div>
      <ReactSlidingPane
        isOpen={openPanel}
        from="right"
        width={slidingPanelWidth}
        closeIcon={(
          <img src={closeIcon} alt="" width="40px" />
        )}
        onRequestClose={() => {
          setOpenPanel(false);
        }}
      >
        <FetalMovement />
      </ReactSlidingPane>
    </div>
  );
}
